import { escapeCql } from "../api/agencyPrefixesService";
var AGENCY_TOKEN = /^(ISBN|ISMN)$/i;
/** Range bounds are integers — a longer number could overflow, it is matched as text only. */
var BOUND_NUMBER = /^\d{1,9}$/;
var tokenize = function (text) {
    return text
        .trim()
        .split(/[\s-]+/)
        .filter(Boolean);
};
/** Splits off a leading agency token (`ISBN`, `ISMN`) from the typed tokens. */
var splitAgency = function (tokens) {
    return tokens.length > 0 && AGENCY_TOKEN.test(tokens[0])
        ? { agency: tokens[0].toUpperCase(), rest: tokens.slice(1) }
        : { agency: null, rest: tokens };
};
/**
 * CQL query of the agency prefix typeahead. The option label is
 * `ISBN 978-80`: a leading agency filters by agency, `978-80` matches
 * international + agency prefix, a single value matches either of them.
 *
 * @param text typed text
 * @returns CQL query with a stable sort
 */
export var agencyPrefixSearchQuery = function (text) {
    var _a = splitAgency(tokenize(text)), agency = _a.agency, rest = _a.rest;
    var _b = rest.map(escapeCql), first = _b[0], second = _b[1];
    var parts = [];
    if (agency)
        parts.push("internationalPrefix.agency==\"".concat(agency, "\""));
    if (second !== undefined) {
        parts.push("internationalPrefix.value==\"".concat(first, "*\" and value==\"").concat(second, "*\""));
    }
    else if (first !== undefined) {
        parts.push("(value==\"".concat(first, "*\" or internationalPrefix.value==\"").concat(first, "*\")"));
    }
    var base = parts.length > 0 ? parts.join(" and ") : "cql.allRecords=1";
    return "".concat(base, " sortBy value id");
};
/**
 * CQL query of the publisher prefix range typeahead. The option label is
 * `80 7000-7999` (agency prefix, start, end) — the typed tokens are matched in
 * that order; a single number matches the agency prefix or either bound. A
 * leading `ISBN` / `ISMN` is ignored, numbers over 9 digits are never compared
 * with the integer bounds.
 *
 * @param text typed text
 * @returns CQL query with a stable sort
 */
export var publisherPrefixRangeSearchQuery = function (text) {
    var rest = splitAgency(tokenize(text)).rest;
    var first = rest[0], start = rest[1], end = rest[2];
    var sort = " sortBy agencyPrefix status start id";
    if (first === undefined)
        return "cql.allRecords=1".concat(sort);
    var agencyClause = "agencyPrefix.value==\"".concat(escapeCql(first), "*\"");
    var parts = [];
    if (start === undefined) {
        parts.push(BOUND_NUMBER.test(first)
            ? "(".concat(agencyClause, " or start==").concat(first, " or end==").concat(first, ")")
            : agencyClause);
    }
    else {
        parts.push(agencyClause);
        if (BOUND_NUMBER.test(start))
            parts.push("start==".concat(start));
        if (end !== undefined && BOUND_NUMBER.test(end))
            parts.push("end==".concat(end));
    }
    return "".concat(parts.join(" and ")).concat(sort);
};
